import React from "react";
import usePreciario from "../../hooks/usePreciario";
import { formatMonto, getValue } from "../../utils";
import { getTipo } from "../../utils/conceptos";
import { Link } from "react-router-dom";

// eslint-disable-next-line no-unused-vars
const keyPriority = ["estimado", "supervisado", "autorizado"];
// eslint-disable-next-line no-unused-vars
const amountPriority = ["importe_solicitado", "importe"];

const toNumber = (value) => {
  const parsed = parseFloat(value);
  return isNaN(parsed) ? 0 : parsed;
};

const ConceptosEstimacion = ({ conceptos }) => {
  const { acumulados, estimacion, handleComments, renderPrecioControl } =
    usePreciario();

  const renderAcumulado = (concepto) => {
    const anterior = acumulados?.find(({ clave }) => clave === concepto.clave);
    if (anterior && anterior !== null) {
      if (anterior.acumulado_estimado > 0) {
        return (
          <Link
            to={`./concepto/${concepto.idConcepto}`}
            className="text-primary text-underline"
          >
            {anterior.acumulado_estimado}
          </Link>
        );
      }
      return anterior.acumulado_estimado;
    }
  };

  const renderConceptos = () => {
    if (Array.isArray(conceptos)) {
      return conceptos.map((concepto) => {
        // Measurements shown per column (mirroring the fallbacks used below).
        const contratista = toNumber(concepto.estimado);
        const supervision = concepto.supervisado
          ? toNumber(concepto.supervisado)
          : contratista;
        const obras = concepto.autorizado
          ? toNumber(concepto.autorizado)
          : concepto.supervisado
          ? toNumber(concepto.supervisado)
          : contratista;
        // Flag a cell with the "Extra" red highlight when the supervisor or
        // obras measurement differs from the contratista's.
        const supervisionDiffers = supervision !== contratista;
        const obrasDiffers = obras !== contratista;
        return (
        <tr
          key={concepto.idConcepto}
          className={`border-bottom hover-light concepto-${getTipo(concepto)}`}
        >
          <td style={{ minWidth: 150 }} className="text-underline">
            <button
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title={concepto.nombre}
              data-bs-title={concepto.nombre}
              data-bs-custom-class="custom-tooltip"
              className="btn px-0 py-0 text-underline fw-normal"
            >
              {concepto.clave}
            </button>
          </td>
          <td>{concepto.unidad}</td>
          <td>{concepto.cantidad}</td>
          <td>{renderAcumulado(concepto)}</td>
          <td style={{ minWidth: 150 }}>
            ${formatMonto(concepto.precio_solicitado)}
          </td>
          {getValue(estimacion, "tipo") === "extra" && (
            <td style={{ minWidth: 200 }}>{renderPrecioControl(concepto)}</td>
          )}
          <td key="estimado">{formatMonto(concepto.estimado)}</td>
          <td key="supervisado" className={supervisionDiffers ? "concepto-extra" : undefined}>
            {concepto.supervisado
              ? formatMonto(concepto.supervisado)
              : formatMonto(concepto.estimado)}
          </td>
          <td key="autorizado" className={obrasDiffers ? "concepto-extra" : undefined}>
            {concepto.autorizado
              ? formatMonto(concepto.autorizado)
              : concepto.supervisado
              ? formatMonto(concepto.supervisado)
              : formatMonto(concepto.estimado)}
          </td>
          <td key="importe_solicitado">${formatMonto(concepto.importe_solicitado)}</td>
          <td key="importe">${formatMonto(concepto.importe)}</td>
          <td>
            <button
              onClick={() => {
                handleComments(concepto);
              }}
              className={`btn btn-sm btn-outline-${concepto.comentarios ? "primary" : "secondary"} ms-2`}
            >
              <i className="fa fa-comment" /> {concepto.comentarios > 0 ? concepto.comentarios : ""}
            </button>
          </td>
        </tr>
        );
      });
    }
  };

  return (
    <div className="table-responsive px-0">
      <table className="table border">
        <thead>
          <tr className="bold text-center small bg-light">
            <td style={{ width: 100 }}>CLAVE</td>
            <td>UNIDAD</td>
            <td style={{ width: 100 }}>CANTIDAD CONTRATADA</td>
            <td style={{ width: 100 }}>CANTIDAD ACUMULADA ANTERIOR</td>
            <td className="text-start">
              {getValue(estimacion, "tipo") === "extra"
                ? "PRECIO CONTRATISTA"
                : "PRECIO"}
            </td>
            {getValue(estimacion, "tipo") === "extra" && (
              <td>PRECIO CONTROL</td>
            )}
            <td>CONTRATISTA</td>
            <td>SUPERVISION</td>
            <td>OBRAS</td>
            <td>IMPORTE SOLICITADO</td>
            <td>IMPORTE AUTORIZADO</td>
            <td>ACCIONES</td>
          </tr>
        </thead>
        <tbody>{renderConceptos()}</tbody>
      </table>
    </div>
  );
};

export default ConceptosEstimacion;
